import React, { useRef,useState } from 'react'; 
import styled from 'styled-components'
import { Snackbar } from '@mui/material';
import { useForm } from 'react-hook-form';
import emailjs from '@emailjs/browser';


const Container = styled.div`
display: flex;
flex-direction: column;
justify-content: center;
position: relative;
z-index: 1;
align-items: center;
@media (max-width: 960px) {
    padding: 0px;
}
`

const Wrapper = styled.div`
position: relative;
display: flex;
justify-content: space-between;
align-items: center;
flex-direction: column;
width: 100%;
max-width: 1350px;
padding: 61px 0px 80px 0px;
gap: 2px;
@media (max-width: 960px) {
    flex-direction: column;
}
`

const Title = styled.div`
font-size: 42px;
text-align: center;
font-weight: 600;
margin-top: 20px;
  color: ${({ theme }) => theme.text_primary};
  @media (max-width: 768px) {
      margin-top: 12px;
      font-size: 32px;
  }
`;

const Desc = styled.div`
    font-size: 18px;
    text-align: center;
    max-width: 600px;
    color: ${({ theme }) => theme.text_secondary};
    @media (max-width: 768px) {
        margin-top: 12px;
        font-size: 16px;
    }
`;


const ContactForm = styled.form`
  width: 95%;
  max-width: 600px;
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.card};
  padding: 32px;
  border-radius: 16px;
  box-shadow: rgba(23, 92, 230, 0.15) 0px 4px 24px;
  margin-top: 28px;
  gap: 12px;
`

const ContactTitle = styled.div`
  font-size: 24px;
  margin-bottom: 6px;
  font-weight: 600;
  color: ${({ theme }) => theme.text_primary};
`

const ContactInput = styled.input`
  flex: 1;
  background-color: transparent;
  border: 1px solid ${({ theme }) => theme.text_secondary};
  outline: none;
  font-size: 18px;
  color: ${({ theme }) => theme.text_primary};
  border-radius: 12px;
  padding: 12px 16px;
  &:focus {
    border: 1px solid ${({ theme }) => theme.primary};
  }
`

const ContactInputMessage = styled.textarea`
  flex: 1;
  background-color: transparent;
  border: 1px solid ${({ theme }) => theme.text_secondary};
  outline: none;
  font-size: 18px;
  color: ${({ theme }) => theme.text_primary};
  border-radius: 12px;
  padding: 12px 16px;
  &:focus {
    border: 1px solid ${({ theme }) => theme.primary};
  }
`

const ContactButton = styled.input`
  width: 100%;
  text-decoration: none;
  text-align: center;
  background: hsla(271, 100%, 50%, 1);
  background: linear-gradient(225deg, hsla(271, 100%, 50%, 1) 0%, hsla(294, 100%, 50%, 1) 100%);
  background: -moz-linear-gradient(225deg, hsla(271, 100%, 50%, 1) 0%, hsla(294, 100%, 50%, 1) 100%);
  background: -webkit-linear-gradient(225deg, rgb(34 33 34) 0%, rgb(57 32 253) 100%);
  padding: 13px 16px;
  margin-top: 2px;
  border-radius: 12px;
  border: none;
  color: ${({ theme }) => theme.text_primary};
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;

  &:hover {
    transform: scale(1.05);
    transition: all 0.4s ease-in-out;
    box-shadow:  20px 20px 60px #1F2634,
    filter: brightness(1);
`

const Contact = () => {
  const { register, handleSubmit, formState: { errors } } = useForm();
  const form = useRef(); 
  const [open, setOpen] = useState(false);

  const sendEmail = async (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
  
    try {
      // Send email using emailjs
      await emailjs.sendForm('service_1crk7cv', 'template_628mr6h', form.current, 'GL7hvUjuCMGZ7EOhU');
      
      // Email sent successfully
      setOpen(true);
    } catch (error) {
      // Failed to send email
      console.log('FAILED...', error.text);
    }
  };

  return (
    <Container id='contact'>
      <Wrapper>
        <Title>Contact</Title>
        <Desc>Feel free to reach out to me for any questions!</Desc>
        <ContactForm ref={form} onSubmit={handleSubmit(sendEmail)} id="contact-form">
          <ContactTitle>Email Me</ContactTitle>
          <ContactInput {...register('user_email', { required: true, pattern: /^\S+@\S+$/i })} placeholder="Your Email" autoComplete="email" />
          {errors.user_email && errors.user_email.type === "required" && <span style={{ color: 'red' }}>Email is required</span>}
          {errors.user_email && errors.user_email.type === "pattern" && <span style={{ color: 'red' }}>Invalid email address</span>}
          <ContactInput {...register('user_name', { required: true })} placeholder="Your Name" autoComplete="name" />
          {errors.user_name && <span style={{ color: 'red' }}>Name is required</span>}
          <ContactInput {...register('subject')} placeholder="Subject" autoComplete="off" />
          <ContactInputMessage {...register('message')} placeholder="Message" rows="4" autoComplete="off" />
          <ContactButton type="submit" value="Send" />
        </ContactForm>

        <Snackbar 
          open={open}
          autoHideDuration={6000}
          onClose={()=>setOpen(false)}
          message="Email sent successfully!"
          severity="success"
        />
      </Wrapper>
    </Container>
  );
};

export default Contact;